
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.336 7.54l2.758 6.062L9.954.266h1.6v1.039h-1.023l-4.203 14.36H5.57L2.336 8.71l-1.32.586-.243-.586 2.563-1.172zm-.602-5.806V.656C3.573.312 4.336.141 5.024.141c.364 0 .7.05 1.007.148.313.099.563.255.75.469.188.213.282.482.282.804 0 .282-.066.527-.196.735-.125.203-.3.38-.523.531-.219.151-.503.3-.852.445v.079c.516.083.93.27 1.242.562.313.287.47.635.47 1.047 0 .365-.097.69-.29.976-.187.287-.476.514-.867.68-.386.167-.857.25-1.414.25a5.712 5.712 0 01-1.977-.351V5.375h.711c.11.333.266.576.469.727.208.15.484.226.828.226.453 0 .794-.104 1.024-.312.234-.209.351-.519.351-.93 0-.438-.154-.77-.46-1-.308-.23-.766-.344-1.376-.344h-.469v-.554c.49-.016.899-.089 1.227-.22.328-.135.565-.307.71-.515.152-.213.227-.456.227-.726 0-.318-.096-.568-.289-.75-.192-.183-.471-.274-.836-.274-.317 0-.588.086-.812.258-.224.172-.396.427-.516.766l-.71.007z","fill":"currentColor"}})])
          )
        }
      }
    